{
  "page": {
    "title": "Miembros",
    "subtitle": "Gestiona los miembros de tu organización"
  },
  "table": {
    "member": "Miembro",
    "role": "Rol",
    "area": "Área",
    "expiration": "Vigencia",
    "status": "Estado",
    "joinedAt": "Fecha de ingreso"
  },
  "toolbar": {
    "search": "Buscar miembros...",
    "invite": "Invitar miembro"
  },
  "filters": {
    "trigger": "Filtros",
    "search": "Buscar miembros",
    "reset": "Limpiar filtros"
  },
  "invite": {
    "title": "Invitar nuevo miembro",
    "description": "Ingresa el correo electrónico de la persona que deseas invitar a la organización.",
    "email": "Correo electrónico",
    "emailPlaceholder": "correo@ejemplo.com",
    "role": "Rol",
    "expiration": "Fecha de vigencia (opcional)",
    "placeholder": "Sin fecha límite",
    "submit": "Enviar invitación",
    "submitting": "Enviando...",
    "cancel": "Cancelar"
  },
  "actions": {
    "openMenu": "Más opciones",
    "viewProfile": "Ver perfil",
    "copyEmail": "Copiar email",
    "workSchedule": "Horario de trabajo",
    "setHireDate": "Establecer fecha de contratación",
    "delete": "Eliminar"
  },
  "setHireDate": {
    "description": "Requerida antes de poder abrir un ciclo de ausencias para {{name}}.",
    "label": "Fecha de contratación",
    "cancel": "Cancelar",
    "save": "Guardar fecha"
  },
  "confirm": {
    "changeStatus": "Cambiar estado",
    "changeStatusDesc": "¿Estás seguro de que deseas {{action}} a \"{{name}}\"?",
    "delete": "Eliminar miembro",
    "deleteDesc": "¿Estás seguro de que deseas eliminar a \"{{name}}\" de la organización? Esta acción no se puede deshacer.",
    "confirm": "Confirmar",
    "cancel": "Cancelar"
  },
  "toast": {
    "statusUpdatedActive": "Miembro activado",
    "statusUpdatedActiveDesc": "El estado de \"{{name}}\" ha sido actualizado",
    "statusUpdatedPending": "Miembro desactivado",
    "statusUpdatedPendingDesc": "El estado de \"{{name}}\" ha sido actualizado",
    "inviteSent": "Invitación enviada",
    "inviteSentDesc": "Se ha enviado una invitación a {{email}}",
    "deleted": "Miembro eliminado",
    "deletedDesc": "{{name}} ha sido eliminado de la organización.",
    "emailCopied": "Email copiado",
    "emailCopiedDesc": "El email {{email}} ha sido copiado al portapapeles.",
    "roleUpdated": "Rol actualizado",
    "roleUpdatedDesc": "El rol de \"{{name}}\" ha sido actualizado",
    "expirationUpdated": "Vigencia actualizada",
    "expirationUpdatedDesc": "La vigencia de \"{{name}}\" ha sido actualizada",
    "hireDateSet": "Fecha de contratación establecida",
    "hireDateSetDesc": "Se estableció la fecha de contratación de {{name}}.",
    "error": "Error",
    "errorDesc": "Por favor, intenta de nuevo más tarde."
  },
  "status": {
    "active": "Activo",
    "inactive": "Inactivo"
  },
  "area": {
    "none": "Sin área",
    "noneDescription": "Sin área asignada",
    "assign": "Asignar área",
    "assignSuccess": "Área asignada correctamente",
    "assignError": "Error al asignar el área",
    "search": "Buscar área...",
    "clear": "Sin área"
  },
  "role": {
    "owner": "Propietario",
    "admin": "Administrador",
    "collaborator": "Colaborador",
    "client": "Cliente",
    "viewer": "Visor"
  },
  "expiration": {
    "none": "Sin vigencia",
    "select": "Seleccionar fecha"
  },
  "tabs": {
    "members": "Miembros",
    "invitations": "Invitaciones pendientes"
  },
  "loading": "Cargando...",
  "empty": "No hay miembros en esta organización",
  "you": "(Tú)",
  "errors": {
    "emailRequired": "El correo electrónico es obligatorio",
    "emailInvalid": "Ingresa un correo electrónico válido",
    "roleRequired": "Selecciona un rol"
  },
  "invitations": {
    "title": "Invitaciones pendientes",
    "empty": "No hay invitaciones pendientes",
    "columns": {
      "email": "Correo",
      "role": "Rol",
      "expires": "Vigencia",
      "sentAt": "Enviada"
    },
    "cancel": "Cancelar",
    "cancelConfirm": "¿Cancelar invitación?",
    "cancelConfirmDesc": "Se revocará la invitación enviada a {{email}}.",
    "cancelledToast": "Invitación cancelada"
  },
  "apiErrors": {
    "notFound": "El miembro no fue encontrado",
    "alreadyExists": "Ya existe un miembro registrado con este correo",
    "cannotChangeOwnerRole": "No es posible cambiar el rol del propietario",
    "cannotDeactivateOwner": "No es posible desactivar al propietario",
    "cannotRemoveOwner": "No es posible eliminar al propietario",
    "clientIdRequired": "Se requiere un cliente para el rol de cliente",
    "clientIdNotAllowed": "El ID de cliente solo aplica al rol de cliente",
    "clientNotInTenant": "El cliente seleccionado no pertenece a esta organización",
    "invitationAlreadyExists": "Ya existe una invitación pendiente para este correo",
    "memberLimitExceeded": "No es posible invitar: se excedería el límite de miembros del plan",
    "inviteDefault": "No fue posible enviar la invitación",
    "toggleDefault": "No fue posible actualizar el estado del miembro",
    "updateDefault": "No fue posible actualizar el miembro",
    "deleteDefault": "No fue posible eliminar el miembro",
    "hireDateDefault": "No fue posible establecer la fecha de contratación",
    "invitationNotFound": "La invitación no fue encontrada",
    "cancelInviteDefault": "No fue posible cancelar la invitación"
  }
}
